import { TCellComponent } from '../List';
import pdfSVG from '../../../../icons/mimetype/pdf.svg';
import jpgSVG from '../../../../icons/mimetype/jpg.svg';
import pngSVG from '../../../../icons/mimetype/png.svg';
import wordSVG from '../../../../icons/mimetype/word.svg';
import excelSVG from '../../../../icons/mimetype/excel.svg';
import dwgSVG from '../../../../icons/mimetype/dwg.svg';
import otherVG from '../../../../icons/mimetype/other.svg';
import { Icon } from '@plone/volto/components';
import React from 'react';

const getIcon = (mimetype: string) => {
  let icon;
  if (mimetype === 'PDF') {
    icon = pdfSVG;
  } else if (mimetype === 'JPEG') {
    icon = jpgSVG;
  } else if (mimetype === 'PNG') {
    icon = pngSVG;
  } else if (mimetype === 'Word') {
    icon = wordSVG;
  } else if (mimetype === 'Excel') {
    icon = excelSVG;
  } else if (mimetype === 'SVG') {
    icon = dwgSVG;
  } else {
    icon = otherVG;
  }

  return icon;
};

const MIMEType: TCellComponent<string> = ({ data, url }) => (
  <Icon name={getIcon(data)} size="1.25em" title={data} />
);

export default MIMEType;
